import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getEmail, getVid, getJobTitle, getCompany, getAssociatedCompanyId, getAssociatedCompanyName } from 'conversations-inbox-lib/contacts/public/operators';
import { useContact } from '../../../crm-integration/hooks/useContact';
import { isKnownContact as isKnownContactOperator } from '../../../contacts/operators/isKnownContact';
import ContactAvatar from 'svh-workspace-ui-lib/ticket-header/public/ContactAvatar';
import { Box } from 'foundations-components/transitional/components/Box';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
// @ts-expect-error type not available yet
import ThreadToolbarPlaceholder from 'conversations-thread-view/thread-toolbar/components/ThreadToolbarPlaceholder';
import ContactDetail from './ContactDetail';
import CompanyDetails from './CompanyDetails';
import { ConversationDetails } from 'svh-workspace-ui-lib/detail-header/public/components';
import { Flex } from 'foundations-components/components/Flex';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { useThreadMetaData } from 'conversations-inbox-lib/detail-header/public/hooks';
import { getMatchedCompanyLink, getContactDetail } from 'svh-workspace-ui-lib/detail-header/public/utils';
import { View } from 'foundations-components/transitional/components/View';
import DetailHeaderWrapper from '../../../unified-inbox/components/DetailHeaderWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadHeader = ({
  threadId,
  children
}) => {
  const {
    asyncContact
  } = useContact({
    threadId
  });
  const {
    startedAt,
    closedAt,
    loading: threadLoading
  } = useThreadMetaData({
    threadId
  });
  const contact = getData(asyncContact);
  const vid = getVid(contact);
  const contactEmail = getEmail(contact) || '';
  const jobTitle = getJobTitle(contact) || '';
  const isKnownContact = isKnownContactOperator(contact);
  const loadingThreadHeader = isLoading(asyncContact);
  const associatedCompanyId = getAssociatedCompanyId(contact) || '';
  const associatedCompanyName = getAssociatedCompanyName(contact) || '';
  const company = getCompany(contact) || '';
  const companyLink = getMatchedCompanyLink({
    associatedCompanyId,
    associatedCompanyName,
    company
  });
  const contactDetail = getContactDetail(contact);
  if (loadingThreadHeader || threadLoading) {
    // TODO: We probably need a new loading state to match with the new header design
    return /*#__PURE__*/_jsx(ThreadToolbarPlaceholder, {});
  }
  return /*#__PURE__*/_jsxs(DetailHeaderWrapper, {
    paddingBlock: "200",
    paddingInline: "400",
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockStart: "100",
      marginInlineEnd: "300",
      children: /*#__PURE__*/_jsx(ContactAvatar, {
        isKnownContact: isKnownContact,
        email: contactEmail,
        contactDetail: contactDetail,
        vid: vid,
        threadId: threadId
      })
    }), /*#__PURE__*/_jsx(Box, {
      basis: 700,
      flexGrow: 1,
      marginBlockStart: "50",
      paddingBlockStart: "25",
      children: /*#__PURE__*/_jsxs(MediaObject, {
        align: "center",
        children: [/*#__PURE__*/_jsx(Box, {
          blockSize: "18px",
          flexShrink: 1,
          children: /*#__PURE__*/_jsx(ContactDetail, {
            contactDetail: contactDetail,
            isKnownContact: isKnownContact
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(CompanyDetails, {
            associatedCompanyId: associatedCompanyId,
            jobTitle: jobTitle,
            company: company || associatedCompanyName,
            companyLink: companyLink,
            isKnownContact: isKnownContact,
            threadId: threadId
          }), startedAt && /*#__PURE__*/_jsxs(Box, {
            flexShrink: 0,
            children: [(company || jobTitle || !isKnownContact) && /*#__PURE__*/_jsx(View, {
              as: "span",
              marginInline: "200",
              children: '•'
            }), /*#__PURE__*/_jsx(ConversationDetails, {
              startedAt: startedAt,
              closedAt: closedAt
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "end",
      children: children
    })]
  });
};
ThreadHeader.displayName = 'ThreadHeader';
export default ThreadHeader;